import { useEffect, useState } from "react";
import { deleteField } from "firebase/firestore";
import { deleteContent, getContents, signInWithEmail, updateContent } from "../../FIREBASECONFIG";

export const useResortsUsersQuery = (collectionName) => {
  const [resortsUsers, setResortsUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadUsers = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getContents(collectionName);
      setResortsUsers(data || []);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUsers();
  }, [collectionName]);

  const refetch = async () => {
    await loadUsers();
  };

  return {
    resortsUsers,
    loading,
    error,
    refetch,
  };
};

export const useResortUserMutation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const createResortsUser = async (userData) => {
    setLoading(true);
    setError(null);
    try {
      const role = (userData.role || "").toLowerCase();
      const hotelId = userData.hotelId || null;
      const city =
        role === "admin" ? "*" : hotelId ? hotelId : "*";

      await signInWithEmail(
        userData.email,
        userData.password,
        userData.name,
        userData.role,
        city,
        hotelId
      );
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      console.error("Error creating resort user:", err);
      return false;
    }
  };

  const updateResortsUser = async (userId, userData) => {
    setLoading(true);
    setError(null);
    try {
      const role = (userData.role || "").toLowerCase();
      const updateData = {
        name: userData.name,
        email: userData.email,
        role: userData.role,
      };

      if (role === "admin") {
        updateData.city = "*";
        updateData.hotelId = deleteField();
      } else if (role === "hoteladmin" || role === "reservationadmin") {
        if (userData.hotelId) {
          updateData.hotelId = userData.hotelId;
          updateData.city = userData.hotelId;
        } else if (userData.hotelId === null) {
          updateData.hotelId = deleteField();
          updateData.city = "*";
        }
      }

      // Only include password if it's provided
      if (userData.password && userData.password.trim()) {
        updateData.password = userData.password;
      }

      await updateContent("users", "", userId, updateData);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      console.error("Error updating resort user:", err);
      return false;
    }
  };

  return {
    createResortsUser,
    updateResortsUser,
    loading,
    error,
  };
};

export const useDeleteResortUserMutation = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteResortUser = async (userId) => {
    setLoading(true);
    setError(null);

    try {
      await deleteContent("users", userId);
      setLoading(false);
      return true;
    } catch (err) {
      setError(err);
      setLoading(false);
      return false;
    }
  };

  return { deleteResortUser, loading, error };
}